module.exports = __webpack_public_path__ + "resources/close-0b0b6f95d9da2b7edaafdb5f466cbaea.svg";